import { render } from "./PeripheralIcon.vue?vue&type=template&id=e4ead876&ts=true"
import script from "./PeripheralIcon.vue?vue&type=script&lang=ts"
export * from "./PeripheralIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PeripheralIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4ead876"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4ead876', __exports__)) {
    api.reload('e4ead876', __exports__)
  }
  
  module.hot.accept("./PeripheralIcon.vue?vue&type=template&id=e4ead876&ts=true", () => {
    api.rerender('e4ead876', render)
  })

}


export default __exports__